import { useState } from "react";
import styles from "./NamePrompt.module.css";

interface Props {
  onVerified: () => void;
}

export function PasswordGate({ onVerified }: Props) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const res = await fetch("/api/dev/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      if (res.ok) {
        onVerified();
      } else {
        setError("パスワードが正しくありません");
        setPassword("");
      }
    } catch {
      setError("通信エラーが発生しました");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h1>Dev Gate</h1>
        <p>開発環境にアクセスするにはパスワードが必要です。</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="パスワード"
          autoFocus
          aria-label="パスワード"
        />
        {error && <p style={{ color: "#dc2626", margin: "0 0 1rem" }}>{error}</p>}
        <button type="submit" disabled={submitting || password.length === 0}>
          {submitting ? "確認中…" : "送信"}
        </button>
      </form>
    </div>
  );
}
